export const ADD_TRUCK_ID = "ADD_TRUCK_ID";
export const ADD_CARRIER_ID = "ADD_CARRIER_ID";
